import React from "react";

export const MixpanelContext = React.createContext();

export const withMixpanel = Comp => props => (
  <MixpanelContext.Consumer>
    {mixpanel => {
      return <Comp mixpanel={mixpanel} {...props} />;
    }}
  </MixpanelContext.Consumer>
);
